var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "loading_svg__lds-curve-bars",
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "0 0"
    }
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    r: 10,
    stroke: "#c5523f",
    strokeDasharray: "31.41592653589793 31.41592653589793",
    transform: "rotate(332.111)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;360 0 0",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    begin: 0,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 20,
    stroke: "#f2b736",
    strokeDasharray: "62.83185307179586 62.83185307179586",
    transform: "rotate(22.57)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;360 0 0",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    begin: -0.25,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 30,
    stroke: "#499255",
    strokeDasharray: "94.24777960769379 94.24777960769379",
    transform: "rotate(120.474)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;360 0 0",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    begin: -0.5,
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 40,
    stroke: "#1875e5",
    strokeDasharray: "125.66370614359172 125.66370614359172",
    transform: "rotate(232.13)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 0 0;360 0 0",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.2 0 0.8 1",
    begin: -0.75,
    repeatCount: "indefinite"
  })))));
};
export { SvgLoading as ReactComponent };
export default "/auth/login/loading.svg";